import { LoadingSplash } from "@/components/molecules";

export interface GuestBookingSplashProps {
  /** Dismiss the waiting UI and abort the in-flight guest booking request. */
  onCancel: () => void;
}

/**
 * Full-screen splash shown while the guest booking-create request is pending (Figma 4106:36539).
 * The guest POST legitimately takes ~15-25s (server mints a Kinde account + Stripe customer + the job), so
 * a bare button spinner is a poor wait — this covers the screen with reassuring copy + an indeterminate
 * indicator so the user knows something is happening.
 *
 * "Cancel Booking" backs the user out of the waiting UI: it aborts the RTK request client-side (see
 * `req.abort()` in GuestPricedBookingSummary) and returns them to the payment step. It does NOT cancel the
 * booking server-side — if the request has already committed the user keeps the booking (acceptable per PRD).
 *
 * Presentation is the shared `LoadingSplash`, so this wait looks identical to the join-operator "Connecting…" step.
 */
export const GuestBookingSplash = ({ onCancel }: GuestBookingSplashProps) => (
  <LoadingSplash
    headingId="guest-booking-splash-heading"
    title="Booking Your Trip…"
    subtitle="Confirming your booking and setting up your account… Hang tight, this only takes a moment."
    statusLabel="Booking in progress"
    onCancel={onCancel}
    cancelLabel="Cancel Booking"
  />
);
